import { CSSProperties } from "react";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {
  display: "flex",
};

export const color: CSSProperties = {
  height: 10,
  width: 10,
  borderRadius: "50%",
  flexShrink: 0,
};

export const smallIcon: CSSProperties = {
  width: 24,
  height: 24,
};

export const smallBtn: CSSProperties = {
  width: 32,
  height: 32,
  padding: 2,
};

export const menuBtn: CSSProperties = {
  cursor: "pointer",
  display: "flex",
};

export const arrowDown: CSSProperties = {
  color: greys.blueGrey,
  marginRight: -2,
};

export const arrowDownHover: CSSProperties = {
  color: greys.slate,
  marginRight: -2,
};

export const popoverColors: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  maxWidth: 140,
  padding: 5,
  flexWrap: "wrap",
};
